import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TransactionBank from "../components/child/TransactionBank";

const BlankPagePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Giao dịch ngân hàng" />

        {/* BlankPageLayer */}
        <TransactionBank />
      </MasterLayout>
    </>
  );
};

export default BlankPagePage;
